var exports = {
  "legal": "x936d19a0--92a3f9--legal",
  "marketing": "x936d19a0--92a3f9--marketing",
  "phrase": "x936d19a0--92a3f9--phrase",
  "link": "x936d19a0--92a3f9--link",
};

module.exports = exports;
